function formatLocationName(address) {
  if (!address) return 'Unknown location';
  const town = address.town || address.city || address.municipality;
  const state = address.state;
  if (town && state) return `${town}, ${state}`;
  if (town) return town;
  if (state) return state;
  if (address.county) return address.county;
  return 'Unknown location';
}

export async function reverseGeocode(lat, lon) {
  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}&addressdetails=1`,
      { headers: { 'User-Agent': 'Traffix/1.0' } },
    );
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const data = await response.json();
    return {
      fullAddress: data.display_name || 'Unknown location',
      road: data.address?.road || null,
      town: data.address?.town || data.address?.city || null,
      municipality: data.address?.municipality || null,
      county: data.address?.county || null,
      state: data.address?.state || null,
      country: data.address?.country || null,
      displayName: formatLocationName(data.address),
    };
  } catch (error) {
    console.error('Error fetching location:', error);
    return { fullAddress: 'Unknown location', displayName: 'Unknown location' };
  }
}

export async function searchGeocode(query, { limit = 5 } = {}) {
  const response = await fetch(
    `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&limit=${limit}`,
    { headers: { 'User-Agent': 'Traffix/1.0' } },
  );
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return response.json();
}

export const getLocationFromCoordinates = reverseGeocode;
